import React, { useState, useEffect, useRef } from "react";
import "../../styles/IndustriesChips.css";

const industries = [
  "Banking & Insurance",
  "Energy",
  "Healthcare",
  "Aeronautics",
  "Telecommunications",
  "Transport & Logistics",
  "Retail & E-commerce",
  "Public Sector & Government",
  "Manufacturing & Industry",
  "Education & Research",
  "Information Technology & Software Development",
  "Defense & Security",
  "Media & Entertainment",
];

export default function IndustriesChips() {
  const [active, setActive] = useState(industries[0]);
  const [paused, setPaused] = useState(false);
  const pausedRef = useRef(false);
  const scrollRef = useRef(null);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const scroll = () => {
      if (!pausedRef.current) {
        container.scrollLeft += 1;

        // If reached end of first list, reset smoothly
        if (container.scrollLeft >= container.scrollWidth / 2) {
          container.scrollLeft = 0;
        }

        // 🔹 Find middle chip
        const containerCenter = container.offsetWidth / 2;
        const chips = container.querySelectorAll(".chip");
        let closestChip = null;
        let minDistance = Infinity;

        chips.forEach((chip) => {
          const rect = chip.getBoundingClientRect();
          const containerRect = container.getBoundingClientRect();
          const chipCenter = rect.left - containerRect.left + rect.width / 2;
          const distance = Math.abs(chipCenter - containerCenter);

          if (distance < minDistance) {
            minDistance = distance;
            closestChip = chip.innerText;
          }
        });

        if (closestChip && closestChip !== active) {
          setActive(closestChip);
        }
      }
    };

    const interval = setInterval(scroll, 30);
    return () => clearInterval(interval);
  }, [active]);

  const handleMouseEnter = () => {
    setPaused(true);
    pausedRef.current = true;
  };

  const handleMouseLeave = () => {
    setPaused(false);
    pausedRef.current = false;
  };

  return (
    <div className="industries" id="industries">
      <h2 className="industries__title">Industries we serve</h2>

      <div
        className="industries__chips-wrapper"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {/* ✅ Duplicate industries for infinite loop */}
        <div className="industries__chips" ref={scrollRef}>
          {[...industries, ...industries].map((name, i) => (
            <button
              key={`${name}-${i}`}
              onClick={() => setActive(name)}
              className={`chip ${active === name ? "active" : ""}`}
            >
              {name}
            </button>
          ))}
        </div>
      </div>

      <div className="industries__card">
        <h3>{active}</h3>
        <p>
          We build tailored solutions for {active.toLowerCase()}, combining
          secure architectures with measurable outcomes.
        </p>
      </div>
    </div>
  );
}
